"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HTMLElementAnchorEngine = void 0;
const HTMLElementAnchorEngine_1 = require("./HTMLElementAnchorEngine");
Object.defineProperty(exports, "HTMLElementAnchorEngine", { enumerable: true, get: function () { return HTMLElementAnchorEngine_1.HTMLElementAnchorEngine; } });
//# sourceMappingURL=index.js.map